import type { SlateRenderElementProps } from "../slateTypes";
import { NodeTypes } from "../slateTypes";
import { BlockCode } from "./BlockCode";
import { CodeLine } from "./CodeLine";
import { Heading } from "./Heading";
import { LinkComponent } from "./LinkComponent";
import { ListItem } from "./ListItem";
import { ListItemText } from "./ListItemText";
import { OrderedList } from "./OrderedList";
import { Paragraph } from "./Paragraph";
import { BlockQuote } from "./Quote";
import { ThematicBreak } from "./ThematicBreak";
import { UnOrderedList } from "./UnOrderedList";

export const renderElement = (props: SlateRenderElementProps) => {
  switch (props.element.type) {
    case NodeTypes.THEMATIC_BREAK:
      return <ThematicBreak {...props} />;
    case NodeTypes.LIST_ITEM_TEXT:
      return <ListItemText {...props} />;
    case NodeTypes.ORDERED_LIST: {
      return <OrderedList {...props} />;
    }
    case NodeTypes.UNORDERED_LIST: {
      return <UnOrderedList {...props} />;
    }
    case NodeTypes.LIST_ITEM: {
      return <ListItem {...props} />;
    }
    case NodeTypes.HEADING: {
      return <Heading {...props} />;
    }
    case NodeTypes.BLOCK_QUOTE: {
      return <BlockQuote {...props} />;
    }
    case NodeTypes.BLOCK_CODE: {
      return <BlockCode {...props} />;
    }
    case NodeTypes.CODE_LINE: {
      return <CodeLine {...props} />;
    }
    case NodeTypes.LINK: {
      return <LinkComponent {...props} />;
    }
    default:
      return <Paragraph {...props} />;
  }
};
